export class PromocodeBaseModel {
  expirationDatetime: string;
  discountPercentage?: number;
  emailBody: string;
  emailSubject: string;

  sendQuestionnaire: boolean;
}
